import { Injectable } from "@angular/core";
import { MatPaginatorIntl } from "@angular/material/paginator";
@Injectable()
export class MatPaginatorCustom extends  MatPaginatorIntl {
    itemsPerPageLabel = 'Records per page';
    nextPageLabel     = 'Next';
    previousPageLabel = 'Prev';

    getRangeLabel = function (page, pageSize, length) {

      if (length === 0 || pageSize === 0) {
        return 'No records to display';
      }
      length = Math.max(length, 0);
      const startIndex = page * pageSize;
      // If the start index exceeds the list length, do not try and fix the end index to the end.
      // const endIndex = length< startIndex+10 ?
      //  length :startIndex+10 ;
      // return +startIndex + 1 + ' - ' + endIndex + ' of ' + length+"records";
      const endIndex = startIndex < length ?
      Math.min(startIndex + pageSize, length) :
      startIndex + pageSize;
    return startIndex + 1 + ' - ' + endIndex + ' / ' + length;
    };

}
